import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import './ContactTab.scss';
import { compose } from 'redux';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const ContactTab = ({
  contactDetails,
  customerComment,
  pickUpAddress,
  creditDetails,
  urlToOfferDetails,
  urlToTransferConfirmation,
  isVehicleFininced,
  offeredPrice,
  commission,
  email,
  t,
}) => {
  const getConnectedText = (firstText, secondText) => `${firstText} ${secondText}`;
  return (
    <div className="contact-tab">
      <div className="details__area">
        <div className="details__box details__name">
          <span className="details__sublabel">
            {t('name')}
          </span>
          {getConnectedText(get(contactDetails, 'first_name'), get(contactDetails, 'last_name'))}
        </div>
        <div className="details__box">
          <span className="details__sublabel">
            {t('telephone')}
          </span>
          {get(contactDetails, 'phone_number')}
        </div>
        <div className="details__box">
          <span className="details__sublabel">
            E-mail
          </span>
          {email}
        </div>
        <div className="details__box">
          <span className="details__sublabel">
            {t('pick_up')}
          </span>
          {getConnectedText(get(pickUpAddress, 'first_name'), get(pickUpAddress, 'last_name'))}<br />
          {get(pickUpAddress, 'street')}<br />
          {getConnectedText(get(pickUpAddress, 'zip_code'), get(pickUpAddress, 'place'))}<br />
          {get(pickUpAddress, 'phone_number')}
        </div>
        <div className="details__box">
          <span className="details__sublabel">
            {t('residence')}
          </span>
          {get(contactDetails, 'pick_up_same_as_offer') ? t('pick_up_same_as') : (
            <span>
              {getConnectedText(get(contactDetails, 'first_name'), get(contactDetails, 'last_name'))}<br />
              {get(contactDetails, 'street')}<br />
              {getConnectedText(get(contactDetails, 'zip_code'), get(contactDetails, 'place'))}
            </span>
          )}
        </div>
        <div className="details__box">
          <span className="details__sublabel">
            {t('transaction_info')}
          </span>
          <span>{t('price')}:&nbsp; </span>
          <span>{offeredPrice}</span>
          <span>{t('unit')}</span><br />
          <span>{t('commission')}:&nbsp; </span>
          <span>{commission}</span>
          <span>{t('unit')}</span><br />
        </div>
        <div className="details__box details__comment">
          <span className="details__sublabel">
            {t('customer_comment')}
          </span>
          {customerComment}
        </div>
      </div>
      {creditDetails && (
        <div className="details__area">
          <div className="details__box" style={{ marginBottom: 0, }}>
            <span className="details__sublabel">
              {t('credit_details')}
            </span>
            {getConnectedText(get(creditDetails, 'credit_bank'), get(creditDetails, 'credit_number'))}
          </div>
        </div>
      )}
      <div className="details__area details__download">
        <span className="details__sublabel">
          {t('download')}
        </span>
        <div className="details__linkList">
          {urlToOfferDetails && <a target="_blank" href={urlToOfferDetails} download rel="noreferrer">Fahrzeugbeschreibung</a>}
          {urlToTransferConfirmation && <a target="_blank" href={urlToTransferConfirmation} download rel="noreferrer">Übergabebestätigung</a>}
          {isVehicleFininced && <a href="/pdf/ablosevollmacht.pdf" download>Ablösevollmacht</a>}
        </div>
      </div>
    </div>
  );
};

ContactTab.propTypes = {
  t: PropTypes.func.isRequired,
  commission: PropTypes.number.isRequired,
  urlToOfferDetails: PropTypes.string,
  urlToTransferConfirmation: PropTypes.string,
  offeredPrice: PropTypes.number.isRequired,
  isVehicleFininced: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  contactDetails: PropTypes.object,
  pickUpAddress: PropTypes.object,
  creditDetails: PropTypes.object,
  customerComment: PropTypes.string,
};

ContactTab.defaultProps = {
  contactDetails: null,
  pickUpAddress: null,
  creditDetails: null,
  customerComment: '',
  urlToOfferDetails: '',
  urlToTransferConfirmation: '',
};

const mapStateToProps = (state) => {
  return {
    offeredPrice: get(state, ['offerDetails', 'data', 'details', 'offered_price']),
    commission: get(state, ['offerDetails', 'data', 'details', 'commission']),
    contactDetails: get(state, ['offerDetails', 'data', 'details', 'contact_details']),
    customerComment: get(state, ['offerDetails', 'data', 'details', 'customer_comment']),
    pickUpAddress: get(state, ['offerDetails', 'data', 'details', 'pick_up_address']),
    creditDetails: get(state, ['offerDetails', 'data', 'details', 'credit_details']),
    urlToOfferDetails: get(state, ['offerDetails', 'data', 'details', 'pdf_url']),
    urlToTransferConfirmation: get(state, ['offerDetails', 'data', 'details', 'transfer_confirmation_url']),
    isVehicleFininced: get(state, ['offerDetails', 'data', 'financed_vehicle']),
    email: get(state, ['offerDetails', 'data', 'details', 'contact_details', 'email']),
  };
};

export default compose(withScopedTranslations('offer_details.contact_tab'), connect(mapStateToProps))(ContactTab);

